import { Card, CardContent } from '@material-ui/core';
import { CodeBlock } from 'app/main/test/CodeBlock';
import { CollapseX } from 'framework/components/CollapseX';
import { LabelledPropertyX } from 'framework/components/labelledProperty/LabelledPropertyX';
import { Typography16pxBold } from 'framework/components/typography/Typography16pxBold';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { formatDate } from 'framework/utils/date/formatDate';
import { patientsQuery_winipro } from 'gen/ApiClient';
import React from 'react';

type WiniproPatientTabProps = {
	patientId: string;
};

export const WiniproPatientTab = ({ patientId }: WiniproPatientTabProps) => {
	// const [item] =
	const [item] = useApiEffect(patientsQuery_winipro, patientId);

	if (!item) {
		return <></>;
	}

	return (
		<Card>
			<CardContent>
				<div className='df-col gap-8'>
					<div>{`Data uit winipro`}</div>
					<LabelledPropertyX label='Id van winipro'>{item.winiproId}</LabelledPropertyX>
					<Typography16pxBold>{`Afspraken #${item.appointments.length}`}</Typography16pxBold>
					{item.appointments.map(app => (
						<CollapseX
							key={app.id}
							expandByDefault={false}
							alignRight={false}
							style={{ marginRight: 'auto' }}
							collapseText={`${formatDate(app.startDate, 'date-and-time')} - ${formatDate(app.endDate, 'date-and-time')}`}
							expandText={`${formatDate(app.startDate, 'date-and-time')} - ${formatDate(app.endDate, 'date-and-time')}`}
							collapseAfter>
							<CodeBlock value={app} />
						</CollapseX>
					))}
					<Typography16pxBold>{`Bestellingen/Dossiers #${item.orders.length}`}</Typography16pxBold>
					{item.orders.map(order => (
						<CollapseX
							key={order.id}
							expandByDefault={false}
							alignRight={false}
							style={{ marginRight: 'auto' }}
							expandText={`${formatDate(order.order.orderDate)} - ${order.id}`}
							collapseText={`${formatDate(order.order.orderDate)} - ${order.id}`}
							collapseAfter>
							<CodeBlock value={order} />
						</CollapseX>
					))}
				</div>
			</CardContent>
		</Card>
	);
};
